module.exports = __webpack_public_path__ + "img/logo-travel.4ed8503d.svg";